import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/blog/:id',
      name: 'blog',
      component: () => import(/* webpackChunkName: "about" */ './views/Blog.vue')
    },
    {
      path: '/blogs',
      name: 'blogs',
      component: () => import( /* webpackChunkName: "about" */ './views/Blogs.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      meta:{
        autentificado:true
      }
    },
    {
      path: '/dash',
      name: 'dash',
      component: () => import( /* webpackChunkName: "dash" */ './views/Dash.vue'),
      meta: {
        autentificado: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ './views/Login.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  let usuario = localStorage.getItem('token')
  
  let autorization = to.matched.some(record => record.meta.autentificado)

  if(autorization && !usuario){
    next('/')
  }else if(!autorization && usuario){
    next()
  }else{
    next()
  }
})

export default router;